import type { FC } from 'react';
import { Box, CircularProgress, Switch } from '@mui/material';

interface UseInAutomationSwitchProps {
  creativeName: string;
  checked: boolean;
  /** The new value is being saved: the switch is replaced by a spinner. */
  loading?: boolean;
  onChange: (checked: boolean) => void;
}

// Events are stopped so using the switch does not toggle the row selection or move grid focus.
const UseInAutomationSwitch: FC<UseInAutomationSwitchProps> = ({ creativeName, checked, loading, onChange }) => (
  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', height: '100%' }}>
    {loading ? (
      <CircularProgress size={18} aria-label="Saving use in automation" />
    ) : (
      <Switch
        size="small"
        checked={checked}
        onChange={(_event, value) => {
          onChange(value);
        }}
        onClick={(event) => {
          event.stopPropagation();
        }}
        onKeyDown={(event) => {
          event.stopPropagation();
        }}
        inputProps={{ 'aria-label': `Use in automation of ${creativeName}` }}
      />
    )}
  </Box>
);

export default UseInAutomationSwitch;
